import React from 'react';
import { toast } from 'react-toastify';
import SubscriptionPanel from '../SubscriptionPanel';

const AccountTab = ({ subscriptionProps, canManageBilling }) => {
  const handleComingSoon = (feature) => {
    toast.info(`${feature} coming soon.`);
  };

  return (
    <>
      {/* Billing is UX-gated here for a clean layout only — the server is the
          real authority on who can manage a shop's subscription. */}
      {/* key is LOAD-BEARING, not decorative: without it, switching the header's
          location leaves the panel mounted, so its local state (tier, startDate,
          editing, interval) survives into the new shop. An admin mid-"Change plan"
          on Shop A who switches to Shop B keeps A's prefilled form and can Assign
          A's tier/date to B's location_id. Remounting per shop discards all four. */}
      {canManageBilling && (
        <SubscriptionPanel key={subscriptionProps.location?.location_id} {...subscriptionProps} />
      )}

      {/* Need Help */}
      <div className="card mb-4">
        <div className="card-header">
          <h4 className="mb-0">
            <i className="fa-sharp fa-regular fa-life-ring mr-2"></i>
            Need Help?
          </h4>
        </div>
        <div className="card-body">
          <p>Having trouble with setup or have questions?</p>
          <div className="d-flex flex-wrap">
            <a href="mailto:support@jobvious.com" className="btn btn-outline-primary btn-sm mr-2 mb-2">
              <i className="fa-sharp fa-regular fa-envelope mr-1"></i> Contact Support
            </a>
            <button className="btn btn-outline-secondary btn-sm mr-2 mb-2" onClick={() => handleComingSoon('Help Center')}>
              <i className="fa-sharp fa-regular fa-book mr-1"></i> Help Center
            </button>
            <button className="btn btn-outline-secondary btn-sm mb-2" onClick={() => handleComingSoon('Tutorials')}>
              <i className="fa-sharp fa-regular fa-video mr-1"></i> Tutorials
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default AccountTab;
